import React from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { colors } from 'styles';
import { breakpoint } from 'utils/mediaQueries';
import IconBlock from 'components/basics/Icons';

const SocialImages = styled(Grid)`
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  a {
    display: flex;
    align-content: center;
    align-items: center;
    padding: 0.5rem;
  }
  path {
    fill: ${props => colors[props.coloricon]};
  }
  ${breakpoint.down('md')`
  flex-direction: row; justify-content:flex-start`}
`;

const SocialIntro = ({ color, data, directionposition }) => {
  return (
    <SocialImages
      container
      alignItems="center"
      coloricon={color}
      direction={directionposition}
      justify={'flex-end'}
    >
      {Object.keys(data).map((social, index) => {
        return (
          <a
            target="_blank"
            href={data[social]}
            key={`SocialBlock${index}`}
            aria-label={`Check his ${social}`}
            rel="noopener"
          >
            <IconBlock icon={social} heightIcon={24} widthIcon={24} />
          </a>
        );
      })}
    </SocialImages>
  );
};
export default SocialIntro;
